import React from "react";
// import { useTranslation } from "react-i18next";

export default function Page404() {
  // const { t } = useTranslation();

  return (
    <section className="ErrorPage">
      <div className="inner-wrapper">
        <div className="button-wrapper">
          <div className="btn btn-home">
            <a href="/">{("Go to Home")}</a>
          </div>
        </div>

        <div className="message-wrapper">{("whoops")}</div>

        <div className="image-wrapper">
          <img
            alt="no items found"
            src="https://cdn.edusity.com/edusityUI/empty-boxes.svg"
          />
        </div>

        <div className="hide">I'm afraid,</div>
        <div className="hide">{window.location.pathname}</div>
        <div className="hide">is not a valid url!</div>
      </div>
    </section>
  );
}
